// extracted by mini-css-extract-plugin
module.exports = {"loader":"NotificationBadge_loader__U5Foo","root":"NotificationBadge_root__zq8Qp"};